import {createSelector} from '@reduxjs/toolkit'
import { APPLICATION_STATUS_PENDING_PAYMENT } from '../../app/constants';

const newBranchApplicationSelector = createSelector(
    [state => state.components,
        state => state.primaryAgencyApplication.application,
        state => state.additionalApplications.additionalBranchApplications],
    ({newBranchApplicationDetails},primaryApplication,additionalBranchApplications) => {

        const newBranchApplications = [];
        
        additionalBranchApplications.forEach(branchApp => {
            // branch status will be marked EXPIRED if not selected for renewal
            if(!branchApp.markedDeleted && !branchApp.markedDoNotRenew && branchApp.applicationStatus === APPLICATION_STATUS_PENDING_PAYMENT)
            {
                if(branchApp.businessLicenceData && 
                    branchApp.businessLicenceData.additionalBranches && 
                    Array.isArray(branchApp.businessLicenceData.additionalBranches))
                {
                    branchApp.businessLicenceData.additionalBranches.forEach(branch => {
                        newBranchApplications.push({
                            ...branch, 
                            id : branchApp.id
                        })
                    })
                }
            }
            
        });

        return Object.assign({},
            newBranchApplicationDetails,
            {primaryApplication},
            {newBranchApplications})
    }
)

export const newBranchApplicationSelect = state => ({
    newBranchDetails: newBranchApplicationSelector(state)
})
